export default "__VITE_PUBLIC_ASSET__b67437f9__"